/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { DateRange } from 'react-date-range';
import { useTranslation } from 'react-i18next';

import Icon from '../Icon/Icon';
import Button from '../Button/Button';
import './RangePicker.scss';

export interface DateRangeProps {
  startDate: Date,
  endDate: Date,
  key: string
}

interface RangePickerProps {
  iconClick: Function,
  handleApply: () => void,
  clear: () => void,
  dateChange:Function,
  ranges: DateRangeProps[],
}

function RangePicker({ handleApply, clear, dateChange, iconClick, ranges }: RangePickerProps) {

  const { t } = useTranslation();

  return (
    <>
      <div className="range-picker__title-container">
        <h2 className="range-picker__title">{ t('betHistory.filterByDate') }</h2>
        <Icon
          onClick={ iconClick }
          className="range-picker__close"
          icon="close"
        />
      </div>
      <DateRange
        onChange={ item => dateChange([item.selection]) }
        ranges={ ranges }
        direction="vertical"
        scroll={ { enabled: true } }
        className="range-picker__calendar"
      />
      <div className="range-picker__bottom">
        <Button
          className="btn--primary range-picker__btn--apply"
          onClick={ handleApply }
        >
          { t('betHistory.apply') }
        </Button>
        <Button
          className="range-picker__btn--clear"
          onClick={ clear }
        >
          { t('betHistory.clear') }
        </Button>
      </div>
    </>
  );
}

export default RangePicker;
